import PropTypes from 'prop-types';
import { Box, MenuItem } from '@mui/material';

import { DataGridSelect } from '../DataGridSelect';

const styles = {
  wrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'inherit',
    paddingBlock: 2,
    // v8 stretches the editing select to fill the cell; pin it to the view-mode chip height (CCW-448)
    '& .MuiInputBase-root': {
      height: '40px !important',
      minHeight: '40px !important',
    },
  },
};

export const DataGridStatusSelect = ({ params, options, labels, colors }) => {
  const handleChange = (event) => {
    const newValue = event.target.value;

    if (newValue !== params.value) {
      params.api.setEditCellValue({
        id: params.id,
        field: params.field,
        value: newValue,
      });
    }

    params.api.stopCellEditMode({ id: params.id, field: params.field });
  };

  const handleClose = () => {
    params.api.stopCellEditMode({ id: params.id, field: params.field });
  };

  return (
    <Box sx={styles.wrapper}>
      <DataGridSelect
        open
        value={params.value}
        onChange={handleChange}
        onClose={handleClose}
        getSelectColor={(value) => colors[value]}
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {labels[option]}
          </MenuItem>
        ))}
      </DataGridSelect>
    </Box>
  );
};

DataGridStatusSelect.propTypes = {
  params: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    field: PropTypes.string.isRequired,
    value: PropTypes.string,
    api: PropTypes.shape({
      setEditCellValue: PropTypes.func.isRequired,
      stopCellEditMode: PropTypes.func.isRequired,
    }).isRequired,
  }).isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  labels: PropTypes.objectOf(PropTypes.string).isRequired,
  colors: PropTypes.objectOf(PropTypes.string).isRequired,
};
